import type {DurationFormat, TimeRemaining} from '../types';

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

export function formatSeconds(totalSeconds: number, format: DurationFormat = 'mm:ss'): string {
  const clamped = Math.max(0, totalSeconds);
  const days = Math.floor(clamped / 86400);
  const hours = Math.floor((clamped % 86400) / 3600);
  const minutes = Math.floor((clamped % 3600) / 60);
  const seconds = clamped % 60;

  if (format === 'hh:mm:ss') {
    const hh = pad(hours + days * 24);
    return `${hh}:${pad(minutes)}:${pad(seconds)}`;
  }

  if (format === 'full') {
    return `${pad(days)} : ${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
  }

  const totalMinutes = Math.floor(clamped / 60);
  return `${pad(totalMinutes)}:${pad(seconds)}`;
}

export function calculateTimeRemaining(
  targetDate: Date,
  expiredLabel = 'پایان زمان'
): TimeRemaining | string {
  const now = new Date();
  const timeLeft = targetDate.getTime() - now.getTime();

  if (timeLeft <= 0) {
    return expiredLabel;
  }

  const days = pad(Math.floor(timeLeft / (1000 * 60 * 60 * 24)));
  const hours = pad(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  const minutes = pad(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)));
  const seconds = pad(Math.floor((timeLeft % (1000 * 60)) / 1000));

  return {
    days,
    hours,
    minutes,
    seconds,
    full: `${days} : ${hours} : ${minutes} : ${seconds}`
  };
}

export function isTimeRemaining(value: TimeRemaining | string): value is TimeRemaining {
  return typeof value === 'object' && value !== null && 'full' in value;
}
